/* Maison MIQU: "The order of the layers" cards (sections/routine-pairing.liquid).
   "Add to cart" posts the card's variant to /cart/add.js, so the shopper stays on the page.
   The header cart count is refreshed; when the theme's cart type is a drawer or a
   notification, that opens instead, exactly as the main Add to cart does.
   Without JavaScript the form posts to /cart/add as a normal form. */
(function () {
  if (window.miquPairingReady) return;
  window.miquPairingReady = true;

  function sectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var element = doc.querySelector(selector);
    return element ? element.innerHTML : '';
  }

  function setBusy(button, busy) {
    if (busy) {
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('aria-busy', 'true');
    } else {
      button.removeAttribute('aria-disabled');
      button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-miqu-pairing')) return;
    if (!window.fetch) return;

    event.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var status = form.querySelector('[data-miqu-pairing-status]');
    var variantInput = form.querySelector('[name="id"]');
    if (!button || !variantInput || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var canRenderCart = cart && typeof cart.renderContents === 'function' && typeof cart.getSectionsToRender === 'function';
    var sections = canRenderCart
      ? cart.getSectionsToRender().map(function (section) { return section.id; })
      : ['cart-icon-bubble'];
    var variantId = Number(variantInput.value);
    var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';

    setBusy(button, true);
    if (status) status.textContent = '';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: sections.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.status) {
          if (status) status.textContent = data.description || data.message || form.dataset.errorText || '';
          return;
        }

        if (canRenderCart) {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(data);
        } else if (data.sections && data.sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) bubble.innerHTML = sectionInnerHTML(data.sections['cart-icon-bubble'], '.shopify-section');
        }

        if (status) status.textContent = form.dataset.addedText || '';

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'miqu-pairing', productVariantId: variantId, cartData: data });
        }
      })
      .catch(function () {
        if (status) status.textContent = form.dataset.errorText || '';
      })
      .finally(function () {
        setBusy(button, false);
      });
  });
})();
